import React from "react";
import PropTypes from 'prop-types';
import TitleBar from '../Layout/titleBar';
import { Row, Col } from 'react-flexbox-grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from '@material-ui/core/styles';
import './localidadesEntrega.css';

const CustomTooltip = withStyles({
    tooltip: {
        fontSize: '14px',
        padding: '10px 14px',
    }
})(Tooltip);

class LocalidadEntregaEdit extends React.Component {
    render() {
        const { localidad, handleOnSave, handleOnCancel, handleOnChange, error } = this.props;
        return (
            <div className='crearEditarLocalidadEntrega'>

                {/* menú superior */}
                <TitleBar
                    title={((localidad?.idLocalidadEntrega === 0) ? 'Nueva ' : 'Editar ') + this.props.entidad}
                    handleOnSave={handleOnSave}
                    handleOnBack={handleOnCancel}
                    showSearch={false}
                />

                <Paper className='myBox no-margin'>
                    <Row>
                        <Col md={12}>
                            <TextField 
                                className='myInput'
                                label='Nombre'
                                name='nombre'
                                fullWidth
                                required
                                value={localidad.nombre || ''}
                                onChange={handleOnChange}
                                error={error && error.nombre}
                                helperText={(error && error.nombre) ? error.nombre : ""}
                                placeholder="Escriba la localidad de entrega en mayúsculas y sin espacios"
                                InputLabelProps={{ 
                                    shrink: true,
                                    style: { marginRight: '28px' }
                                }}
                                style={{ margin: "10px", width: "98%", }}
                                InputProps={{
                                    endAdornment: (
                                        <CustomTooltip title="Este campo debe estar en mayúsculas y sin espacios">
                                            <InfoIcon style={{ fontSize: '20px', marginLeft: '4px', color: '#1976d2' }} />
                                        </CustomTooltip>
                                    )
                                }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <TextField 
                                className='myInput'
                                label='Descripción'
                                name='descripcion'
                                fullWidth
                                required
                                value={localidad.descripcion || ''}
                                onChange={handleOnChange}
                                error={error && error.descripcion}
                                helperText={(error && error.descripcion) ? error.descripcion : ""}
                                placeholder="Nombre que aparecerá en el listado de localidades de entrega activas"
                                InputLabelProps={{ 
                                    shrink: true,
                                    style: { marginRight: '28px' }
                                }}
                                style={{ margin: "10px", width: "98%", }}
                                InputProps={{
                                    endAdornment: (
                                        <CustomTooltip title="Primera letra de cada palabra en mayúscula">
                                            <InfoIcon style={{ fontSize: '20px', marginLeft: '4px', color: '#1976d2' }} />
                                        </CustomTooltip>
                                    )
                                }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={localidad.estado}
                                        onChange={(e) => {handleOnChange({ target: { name: 'estado', value: e.target.checked } })}}
                                        name="estado"
                                        color="primary"
                                    />
                                }
                                label="Activo"
                                style={{ margin: "10px" }}
                            />
                        </Col>
                    </Row>
                </Paper>
            </div>
        );
    }
};

LocalidadEntregaEdit.propTypes = {
    localidad: PropTypes.object.isRequired,
    handleOnSave: PropTypes.func.isRequired,
    handleOnCancel: PropTypes.func.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    error: PropTypes.object,
};

LocalidadEntregaEdit.defaultProps = {
    localidad: {},
};

export default LocalidadEntregaEdit;